import React, { useEffect, useState, useContext } from 'react';
//Material ui.
import {
  makeStyles,
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
//componente
import TopNav from '../common/TopNav';
//Componentes
import Container from '../Elements/Container';
import AlertComponent from '../Elements/AlertComponent';
import UserContext from '../../context/UserContext';
import CardComponent from './CardComponent';
import ModalPay from './ModalPay';
//Servicios
import {
  changeStateOrder,
  getLastOrderWithAddons,
  getpaymentInfo,
  payDebt,
  purchasePlan,
  vencerplan,
} from '../../services/payments';
import { getNotificationsNumber } from '../../services/notifications';
import { Alert, AlertTitle, Button, Stack } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';
import { useHistory } from 'react-router-dom';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { getPlanLevel, RENEWAL } from './helpers';
import InfoIcon from '@mui/icons-material/Info';
import ActualPlanInfo from './ActualPlanInfo';
import useDeviceDetect from '../../hooks/useDeviceDetect';
import { Link } from 'react-router-dom';
import { initMercadoPago } from '@mercadopago/sdk-react';
import MercadoPagoForm from './MercadoPagoForm';
const useStyles = makeStyles(theme => ({
  containerPlans: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    display: 'flex',
    justifyContent: 'flex-start',
    overflowX: 'auto',
    '@media (max-width: 1400px)': {
      flexWrap: 'wrap',
      marginLeft: theme.spacing(1),
      overflow: 'hidden',
    },
  },
  textPrimary: {
    color: theme.palette.primary.main,
  },
}));

export default function Payments() {
  const { isMobile } = useDeviceDetect(720);
  const CBU = '0720055720000001750922';
  const ALIAS = 'POWER.METER.SAS';
  const history = useHistory();
  const classes = useStyles();
  const { plan } = useContext(UserContext);
  const [close, setClose] = useState(false);
  const [msg, setMsg] = useState({
    msg: '',
    type: 'error',
  });
  const [loading, setLoading] = useState(false);
  const [purchasingPlan, setPurchasingPlan] = useState(false);
  const [purchasing, setIsPurchasing] = useState(false);
  const [purchaseType, setPurchaseType] = useState(null);
  const [transfering, setIsTransfering] = useState(false);
  const [plans, setPlans] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [usage, setUsage] = useState({});
  const [purchases, setPurchases] = useState([]);
  const [lastPurchase, setLastPurchase] = useState({});
  const [fixedCosts, setFixedCosts] = useState([]);
  const [openModalPay, setOpenModalPay] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [notificationsPendings, setNotificationsPendings] = useState(null);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [purchaseId, setPurchaseId] = useState(null);
  const [proporsionalPayment, setProporsionalPayment] = useState(false);
  const [currency, setCurrency] = useState('ARS');
  const [products, setProducts] = useState([]);
  const [initialProducts, setInitialProducts] = useState([]);
  const [limits, setLimits] = useState({});
  const [amountToTransfer, setAmountToTransfer] = useState(null);
  const PENDING_PAYMENT = 'Pendiente de Pago';
  const mercadopagoImg = '/images/mercadopago-logo.svg';
  const [timeLeft, setTimeLeft] = useState(null);
  const [openIncompleteDataModal, setOpenIncompleteDataModal] = useState(false);
  const [showIncompleteDataAlert, setShowIncompleteDataAlert] = useState(false);
  const [openUnsuscribedModal, setOpenUnsuscribedModal] = useState(false);
  const [openPayDebt, setOpenPayDebt] = useState(false);
  const [payingDebt, setPayingDebt] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const renew = searchParams.get("renew");
  const FREEPLAN = {
    name: "Gratuito",
    costo_mensual: "0",
  }

  useEffect(() => {
    // precarga img
    const img = new Image();
    img.src = mercadopagoImg;
    getPayments().then((res) => {
      if(renew === 'true') {
        setPurchaseType(RENEWAL);
        setOpenModalPay(true);
        let plans = res?.data?.plans;
        let selectedPlan = plans.find(plan => plan.name === res?.data?.info_user?.plan_actual);
        setSelectedPlan(selectedPlan);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      !loading &&
      notificationsPendings &&
      plans.length &&
      products.length &&
      userInfo
    ) {
      changeCurrency();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currency, loading]);

  useEffect(() => {
    let lastPurchase = purchases[0];
    if (lastPurchase?.estado === PENDING_PAYMENT) {
      const expirationDate = new Date(lastPurchase.expiracion_link);
      let interval;

      const updateCountdown = () => {
        const now = new Date();
        const diffMs = expirationDate.getTime() - now.getTime();
        const diffSeconds = Math.max(Math.floor(diffMs / 1000), 0);

        const minutes = Math.floor(diffSeconds / 60);
        const seconds = diffSeconds % 60;

        if (minutes < 0 || (minutes === 0 && seconds <= 0)) {
          clearInterval(interval);
          setTimeLeft(null);
          return;
        }

        setTimeLeft({ minutes, seconds });
      };
      updateCountdown();
      interval = setInterval(updateCountdown, 1000);

      return () => clearInterval(interval);
    }
  }, [purchases]);

  const formatPrice = price => {
    if (currency === 'ARS') {
      return `$${price} ARS`;
    } else {
      return `U$S ${price}`;
    }
  };

  const getPayments = async () => {
    setLoading(true);
    try {
      let notifications = await getNotificationsPending();
      const lastOrder = await getLastOrderWithAddons();
      const lastOrderAux = lastOrder?.data;

      setLastPurchase(lastOrderAux);
      setNotificationsPendings(notifications?.data);
      const response = await getpaymentInfo();
      let userAux = response?.data?.info_user;
      setUserInfo(userAux);
      // Verificar si los datos fiscales están incompletos
      if (userAux?.datos_fiscales?.datos_completos === false) {
        setShowIncompleteDataAlert(true);
      } else {
        setShowIncompleteDataAlert(false);
      }

      setUsage(response?.data.usage);
      showPlans(response?.data);
      setPurchases(response?.data?.compras);

      loadAmountToTransfer(
        response?.data?.compras,
        notifications?.data?.last_compra
      );
      setProporsionalPayment(response?.data?.proporsional);
      setLimits(response?.data?.limits);
      let perksToShow = response?.data?.perks?.filter(perk => perk.habilitado)
      setProducts(perksToShow);
      setInitialProducts(response?.data?.perks);
      setFixedCosts(response?.data?.costos_fijos);
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      if (error?.response?.status === 409) {
        setOpenIncompleteDataModal(true);
        return;
      }
      setMsg({
        msg: 'Error al cargar la información de los planes',
        type: 'error',
      });
      setClose(true);
    }
  };

  const loadAmountToTransfer = (purchases, purchaseId) => {
    if (!purchases || !purchases.length) return;
    let price = purchases?.find(item => item.id === purchaseId)?.total_ars || 0;
    setPurchaseId(purchaseId);
    setAmountToTransfer(price);
  };

  const showPlans = data => {
    let plansAux = [...data?.plans];
    let actualPlan = plansAux.find(
      item => item.name === data?.info_user?.plan_actual
    );

    if (actualPlan) {
      // Quitar el plan actual de la lista
      plansAux.splice(plansAux.indexOf(actualPlan), 1);
      // Ordenar el resto por costo_mensual (string convertido a número) de menor a mayor
      plansAux.sort(
        (a, b) => Number(a.costo_mensual) - Number(b.costo_mensual)
      );
      if (!data.consentimiento_downgrade_activo) {
        plansAux.unshift(FREEPLAN);
      }
      // Poner el plan actual primero
      setPlans([actualPlan, ...plansAux]);
    } else {
      // Si no hay plan actual, solo ordenar por costo_mensual de menor a mayor
      plansAux.sort(
        (a, b) => Number(a.costo_mensual) - Number(b.costo_mensual)
      );
      setPlans(plansAux);
    }
  };

  const getNotificationsPending = async () => {
    const notifications = await getNotificationsNumber();
    return notifications;
  };

  const handleOpenCloseModalPay = async plan => {
    setSelectedPlan(plan);
    setOpenModalPay(!openModalPay);
  };

  const handlePurchase = async purchase => {
    setPurchasingPlan(true);
    try {
      let res = await purchasePlan(purchase);
      setPurchasingPlan(false);
      if (res) {
        if (res.data?.estado === 'Pagado') {
          history.push('/pago_ok');
        } else {
          if (purchase.transferencia) {
            setPurchaseId(res?.data?.id);
            setAmountToTransfer(res?.data?.total_ars);
            setIsTransfering(true);
          } else {
            trackPayment();
            openLinkInNewTab(res?.data?.link_pago);
          }
          setOpenModalPay(false);
        }
      }
    } catch (error) {
      setPurchasingPlan(false);
      setMsg({
        msg: 'Error interno al procesar la compra.',
        type: 'error',
      });
      setClose(true);
      setOpenModalPay(false);
    }
  };

  const trackPayment = () => {
    const interval = setInterval(async () => {
      let notifications = await getNotificationsPending();
      setNotificationsPendings(notifications?.data);
      if (notifications?.data?.estado_compra === 'Completada') {
        clearInterval(interval);
        history.push('/pago_ok');
      }
    }, 20000);

    setTimeout(() => clearInterval(interval), 300000);
  };

  const openLinkInNewTab = link => {
    setIsPurchasing(true);
    window.open(link, '_blank');
  };

  const handleCancelOrder = async () => {
    let order = {
      compra_id: notificationsPendings.last_compra,
      estado: 2,
    };
    try {
      await changeStateOrder(order);
      setMsg({
        msg: 'Órden cancelada correctamente',
        type: 'success',
      });
      setClose(true);
      setOpenConfirmationDialog(false);
      getPayments();
    } catch (error) {
      console.error(error);
      setMsg({
        msg: 'Ocurrió un error al cancelar la órden.',
        type: 'error',
      });
      setClose(true);
      setOpenConfirmationDialog(false);
    }
  };

  const changeCurrency = () => {
    if (
      !notificationsPendings ||
      !plans.length ||
      !products.length ||
      !userInfo
    )
      return;

    //aplica cambio para planes
    let plansAux = [...plans];
    plansAux.forEach(plan => {
      plan.price =
        currency === 'ARS'
          ? plan.costo_mensual * notificationsPendings?.usd
          : plan.costo_mensual;
    });

    //aplica cambio para perks
    let productsAux = [...products];
    productsAux.forEach(product => {
      product.price =
        currency === 'ARS'
          ? product.precio_unitario * notificationsPendings?.usd
          : product.precio_unitario;
      product.quantity = 0;
    });

    //aplica cambio para credito
    userInfo.creditRefund =
      currency === 'ARS'
        ? userInfo.credito_rembolso * notificationsPendings?.usd
        : userInfo.credito_rembolso;
    userInfo.manualCredits =
      currency === 'ARS'
        ? userInfo.creditos_manuales * notificationsPendings?.usd
        : userInfo.creditos_manuales;

    //aplica cambio para costos fijos
    let fixedCostsAux = [...fixedCosts];
    fixedCostsAux.forEach(cost => {
      cost.price =
        currency === 'ARS'
          ? cost.costo_mensual * notificationsPendings?.usd
          : cost.costo_mensual;
    });

    setUserInfo((prev) => ({
      ...prev,
      total_debt: currency === 'ARS'
        ? userInfo.total_deuda * notificationsPendings?.usd
        : userInfo.total_deuda,
    }));
    setFixedCosts(fixedCostsAux);
    setPlans(plansAux);
    setProducts(productsAux);
  };

  const formatToLocaleString = number => {
    return Number(number).toLocaleString('es-AR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  const cleanProductsSelecteds = () => {
    let productsAux = [...products];
    productsAux.map(product => (product.quantity = 0));
    setProducts(productsAux);
  };

  const formatDate = dateString => {
    if (!dateString) return '-';
    let datePart = dateString.split(' ')[0];
    let [year, month, day] = datePart.split('-');
    return `${day}/${month}/${year}`;
  };

  const expiredLink = () => {
    if (purchases[0]?.estado === PENDING_PAYMENT) {
      const expirationDate = new Date(purchases[0]?.expiracion_link);
      if (expirationDate < new Date()) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const handlePayDebt = async token => {
    try {
      setPayingDebt(true);
      let body = {
        card_token: token,
      }
      await payDebt(body);
      setPayingDebt(false);
      setMsg({
        msg: 'Deuda saldada correctamente',
        type: 'success',
      });
      setOpenPayDebt(false);
      getPayments();
    } catch (error) {
      console.error('Error paying debt:', error);
      setPayingDebt(false);
      setMsg({
        msg: 'Error al procesar el pago de la deuda.',
        type: 'error',
      });
      setOpenPayDebt(false);
    }
  };

  return (
    <>
      {openModalPay && (
        <ModalPay
          openModalPay={openModalPay}
          handleOpenCloseModalPay={() => {
            setOpenModalPay(false);
            cleanProductsSelecteds();
          }}
          selectedPlan={selectedPlan}
          userInfo={userInfo}
          handlePurchase={handlePurchase}
          purchasingPlan={purchasingPlan}
          currency={currency}
          products={products}
          setProducts={setProducts}
          usdCotization={notificationsPendings?.usd}
          fixedCosts={fixedCosts}
          purchaseType={purchaseType}
          lastPurchase={lastPurchase}
          proporsionalPayment={proporsionalPayment}
          initialProducts={initialProducts}
        />
      )}
      <AlertComponent
        severity={msg.type}
        msg={msg.msg}
        setClose={setClose}
        close={close}
      />
      <TopNav titulo="Pagos" subtitulo="| Planes" />
      {userInfo.compra_pendiente_asignacion && (
        <Box marginLeft={isMobile ? 0 : '65px'}>
          <Alert variant="filled" style={{ borderRadius: 0 }} severity={'info'}>
            <span>
              {getPlanLevel(lastPurchase.plan_actual) ===
                getPlanLevel(lastPurchase.plan_utlima_compra) &&
                `La asignación de la nueva compra se asignará el ${formatDate(
                  lastPurchase?.fecha_vencimiento_plan_actual
                )} `}
              {getPlanLevel(lastPurchase.plan_actual) >
                getPlanLevel(lastPurchase.plan_utlima_compra) &&
                `El nuevo plan contratado será asignado una vez finalizada la suscripción.${lastPurchase?.fecha_vencimiento_plan_actual
                  ? `El cambio se realizara el ${formatDate(
                    lastPurchase?.fecha_vencimiento_plan_actual
                  )}`
                  : ''
                } `}
              {getPlanLevel(lastPurchase.plan_actual) <
                getPlanLevel(lastPurchase.plan_utlima_compra) &&
                `La asignación de la nueva compra se asignará el ${formatDate(
                  lastPurchase?.fecha_vencimiento_plan_actual
                )}`}
            </span>
          </Alert>
        </Box>
      )}

      <Container>
        {(userInfo.total_deuda > 0 && !userInfo.en_tolerancia) && (
          <Alert
            variant="filled"
            style={{ borderRadius: 0 }}
            severity={'error'}
          >
            <span>
              Tienes una deuda pendiente de :{' '}
              {formatPrice(
                Number(userInfo.total_debt).toLocaleString('es-AR', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                })
              )}
              .{' '}
              <b
                onClick={() => setOpenPayDebt(true)}
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
              >
                Pagar ahora
              </b>
            </span>
          </Alert>
        )}
        {showIncompleteDataAlert && (
          <Alert
            variant="filled"
            style={{ borderRadius: 0 }}
            severity={'warning'}
          >
            <span>
              Tus datos de facturación están incompletos. Para poder realizar
              pagos, por favor completa los datos en la sección de{' '}
              <b>
                <Link
                  style={{ color: 'inherit', cursor: 'pointer' }}
                  to="/configuracion-cuenta"
                >
                  Configuración de cuenta
                </Link>
              </b>
              .
            </span>
          </Alert>
        )}
        {plan?.info.excluido_de_pagos && (
          <Alert
            variant="filled"
            style={{ borderRadius: 0 }}
            severity={'warning'}
          >
            <span>
              Tu cuenta se encuentra excluida de pagos. Ante cualquier consulta,
              por favor comunicate con soporte.
            </span>
          </Alert>
        )}
        <Box
          display={'flex'}
          flexWrap={'wrap'}
          justifyContent={'space-between'}
          mt={3}
          mb={2}
          mx={6}
          alignItems={'start'}
        >
          <ActualPlanInfo
            userInfo={userInfo}
            usage={usage}
            limits={limits}
            loading={loading}
            purchases={purchases}
            lastPurchase={lastPurchase}
          />
          <Box
            display={'flex'}
            flexWrap={'wrap'}
            alignItems={'center'}
            style={{ gap: '10px' }}
          >
            {notificationsPendings?.estado_compra !== PENDING_PAYMENT && (
              <FormControl variant="outlined" size="small">
                <InputLabel>Moneda</InputLabel>
                <Select
                  value={currency}
                  onChange={e => {
                    setCurrency(e.target.value);
                  }}
                  label="Moneda"
                >
                  <MenuItem value="ARS">ARS</MenuItem>
                  <MenuItem value="USD">USD</MenuItem>
                </Select>
              </FormControl>
            )}
            <Button
              variant="contained"
              color="primary"
              startIcon={<CreditCardIcon />}
              onClick={() => history.push('/compras')}
            >
              Historial de compras
            </Button>
          </Box>
        </Box>

        {loading &&
          notificationsPendings?.estado_compra !== PENDING_PAYMENT && (
            <Box mt={6} display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          )}

        {notificationsPendings?.estado_compra === PENDING_PAYMENT ? (
          <Alert
            severity="info"
            variant="outlined"
            sx={{
              maxWidth: notificationsPendings?.link_pago ? 670 : 600,
              mx: 'auto',
              p: 2,
              borderRadius: 2,
              marginTop: 5,
              width: '100%',
            }}
          >
            <Box
              display={'flex'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <AlertTitle>Pago pendiente</AlertTitle>
              <Box mr={2}>
                <CircularProgress size={25} />
              </Box>
            </Box>
            <p>
              Estamos validando tu pago, por favor, si aún no lo has hecho,
              realiza el pago. <br />
              Si ya lo realizaste, no canceles la órden.
            </p>
            <Stack
              direction="row"
              spacing={2}
              mt={2}
              justifyContent={'flex-end'}
              width={'100%'}
            >
              <Button
                onClick={() => setOpenConfirmationDialog(true)}
                style={{ fontSize: '12px' }}
              >
                Cancelar órden
              </Button>

              {notificationsPendings?.link_pago && (
                <Box display="flex" alignItems="center" gap={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<CreditCardIcon />}
                    onClick={() =>
                      openLinkInNewTab(notificationsPendings?.link_pago)
                    }
                    disabled={expiredLink()}
                  >
                    Pagar
                    {!expiredLink() && timeLeft && (
                      <Box
                        marginLeft={1}
                        position="relative"
                        display="flex"
                        alignItems="center"
                      >
                        <CircularProgress size={30} thickness={5} />
                        <Box
                          position="absolute"
                          top={0}
                          left={0}
                          width="100%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <span style={{ fontSize: '10px' }}>
                            {' '}
                            {timeLeft?.minutes}:
                            {timeLeft?.seconds?.toString()?.padStart(2, '0')}
                          </span>
                        </Box>
                      </Box>
                    )}
                  </Button>
                </Box>
              )}
              <Button
                variant="contained"
                color="primary"
                startIcon={<AccountBalanceIcon />}
                onClick={() => setIsTransfering(true)}
              >
                Pagar por transferencia
              </Button>
            </Stack>
          </Alert>
        ) : (
          <Box width={'100%'} display="flex" justifyContent="center">
            {/* <button onClick={() => {
           vencerplan()
        }}>vencer</button> */}
            <Box className={classes.containerPlans}>
              {plans.map(item => {
                return (
                  <CardComponent
                    handleOpenCloseModalPay={handleOpenCloseModalPay}
                    userInfo={userInfo}
                    key={item?.id}
                    plan={item}
                    currency={currency}
                    disabled={
                      userInfo?.compra_pendiente_asignacion ||
                      userInfo?.datos_fiscales?.datos_completos === false ||
                      plan?.info?.excluido_de_pagos
                    }
                    setPurchaseType={setPurchaseType}
                    purchases={purchases}
                    lastPurchase={lastPurchase}
                    setOpenUnsuscribedModal={setOpenUnsuscribedModal}
                    notificationsPendings={notificationsPendings}
                    setMsg={setMsg}
                    setClose={setClose}
                    hasPurchases={purchases.length > 0}
                  />
                );
              })}
            </Box>
          </Box>
        )}
      </Container>
      <Dialog open={purchasing}>
        <DialogTitle>Compra de nuevo plan</DialogTitle>
        <DialogContent>
          Te redirigimos a la página de pago, estamos validando que se efectúe
          el pago para continuar...
        </DialogContent>
        <Box my={6} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
        <DialogActions>
          <Button
            onClick={() => {
              setIsPurchasing(false);
              getPayments();
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openPayDebt} size="md">
        <DialogTitle>Pago de deuda</DialogTitle>
        <DialogContent>
          El valor a pagar es de {' '}
          {formatPrice(
            Number(userInfo.total_debt).toLocaleString('es-AR', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })
          )}
          . A continuación, ingresa tus datos de pago para saldar la deuda
          pendiente.
          <Box mt={1}>
            <MercadoPagoForm
              amount={userInfo.total_debt}
              email={userInfo?.email}
              save={handlePayDebt}
              purchasingPlan={payingDebt}
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpenPayDebt(false);
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={transfering}>
        <Alert severity="info" style={{ marginTop: 4 }}>
          <AlertTitle>El pago puede demorar hasta 48 horas hábiles</AlertTitle>
        </Alert>
        <Box ml={4} mr={4}>
          <DialogTitle>Datos para Transferencia Bancaria</DialogTitle>
          <DialogContent>
            <Typography mb={2} color="error">
              El monto total debe abonarse en <strong>pesos argentinos</strong>.
              Total:{' '}
              <strong>
                {loading ? (
                  <CircularProgress
                    style={{ marginTop: 2, marginLeft: 2 }}
                    size={15}
                  />
                ) : (
                  `$${formatToLocaleString(amountToTransfer)}`
                )}
              </strong>
            </Typography>
            <Typography>
              <strong>Banco:</strong> Banco Santander
            </Typography>
            <Typography>
              <strong>Número de Cuenta:</strong> 055-017509/2
            </Typography>
            <Typography>
              <strong>CBU:</strong> {CBU}
              <IconButton
                size="small"
                onClick={() => {
                  window.navigator.clipboard.writeText(CBU);
                }}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Typography>
            <Typography>
              <strong>Alias:</strong> {ALIAS}
              <IconButton size="small">
                <ContentCopyIcon
                  fontSize="small"
                  onClick={() => {
                    window.navigator.clipboard.writeText(ALIAS);
                  }}
                />
              </IconButton>
            </Typography>
            <Typography>
              <strong>Razón Social:</strong> POWERMETER SAS
            </Typography>
            <Typography>
              <strong>Número de referencia:</strong> {purchaseId}
            </Typography>
            <Box mt={2}>
              <Typography variant={'body1'}>
                Una vez realizado el pago, enviar comprobante a
                <a href="mailto:administracion@powermeter.com.ar">
                  {' '}
                  administracion@powermeter.com.ar
                </a>{' '}
                <br />
                Con el asunto: Compra Powermate - #{purchaseId}
                <IconButton
                  size="small"
                  onClick={() => {
                    window.navigator.clipboard.writeText(
                      `Compra Powermate - #${purchaseId} `
                    );
                  }}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>{' '}
                <br />
                Con el cuerpo: <b>{plan.info.email}</b> (tu email)
                <IconButton
                  size="small"
                  onClick={() => {
                    window.navigator.clipboard.writeText(`${plan.info.email}`);
                  }}
                ></IconButton>
                <Box display="flex" alignItems="center" mt={1}>
                  <InfoIcon color="primary" sx={{ mr: 1 }} />
                  No te olvides de adjuntar el comprobante de pago!
                </Box>{' '}
                <br />
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setIsTransfering(false);
                getPayments();
              }}
              color="primary"
            >
              Listo
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
      <ConfirmationDialog
        open={openConfirmationDialog}
        setOpen={setOpenConfirmationDialog}
        title={'¿Está seguro de cancelar la órden?'}
        content={
          'En caso de continuar se cancelará la órden anteriormente creada y podrá seleccionar otro plan'
        }
        handleConfirmation={handleCancelOrder}
      />
      <Dialog
        open={openUnsuscribedModal}
        onClose={() => setOpenUnsuscribedModal(false)}
        aria-labelledby="incomplete-data-dialog-title"
        fullWidth
      >
        <DialogTitle id="incomplete-data-dialog-title">
          Suscripción cancelada correctamente
        </DialogTitle>
        <DialogContent>
          <p>
            Tu suscripción fue cancelada exitosamente, puedes volver a
            suscribirte en cualquier momento.
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenUnsuscribedModal(false);
              window.location.reload();
            }}
            color="primary"
            variant="contained"
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openIncompleteDataModal}
        onClose={() => setOpenIncompleteDataModal(false)}
        aria-labelledby="incomplete-data-dialog-title"
        fullWidth
      >
        <DialogTitle id="incomplete-data-dialog-title">
          Datos de facturación incompletos
        </DialogTitle>
        <DialogContent>
          <p>
            Tus datos de facturación estan incompletos. Para poder realizar
            pagos, porfavor completa los datos en la sección de{' '}
            <b>Configuración de cuenta</b>
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenIncompleteDataModal(false);
              history.push('/configuracion-cuenta');
            }}
            color="primary"
            variant="contained"
          >
            Completar datos
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
